export enum HelpRegistryMappings {
  ONBOARDING_ORDERS = 'sandboxMode',
  SANDBOX_BUILDING_OVERVIEW = 'SandboxBuildingOverview',
}

export const helpRegistry: HelpRegistry = {
  [HelpRegistryMappings.ONBOARDING_ORDERS]: {
    key: HelpRegistryMappings.ONBOARDING_ORDERS,
    title: 'Order overview help',
    items: [
      {
        id: 'orders-list',
        label: 'Wo finde ich meine Aufträge?',
        action: 'showDriver',
        steps: [
          {
            element: "div[data-testid='orderListLastUpdated'] + div",
            popover: {
              title: 'Auftragsliste',
              description:
                'Hier findest du alle deine Aufträge, sortiert nach Datum und Status.',
              position: 'mid-center',
            },
          },
          {
            element: "div[data-testid='refreshOrdersButton']",
            popover: {
              title: 'Aufträge aktualisieren',
              description:
                'Wenn deine Aufträge nicht automatisch angezeigt werden, kannst du die Liste aktualisieren, um die neuesten Daten abzurufen.',
              position: 'bottom',
            },
          },
          {
            element: "div[data-testid='workTypeCode_BE']",
            popover: {
              title: 'Auftragsart',
              description:
                'Die Auftragsart zeigt dir an, welche Art von Auftrag du ausführen wirst.',
              position: 'mid-center',
            },
          },
          {
            element: "div[data-testid='orderAddress']",
            popover: {
              title: 'Hauptadresse',
              description:
                'Hier befindet sich der Einsatzort. Das Symbol auf der rechten Seite hilft dir bei der Navigation, sofern nötig.',
              position: 'bottom',
            },
          },
          {
            element: "div[data-testid='orderNotes']",
            popover: {
              title: 'Deine Aufgaben',
              description:
                'In den Notizen findest du alle Aufgaben und Informationen, die du für diesen Auftrag benötigst.',
              position: 'left',
            },
          },
          {
            element: "button[data-testid='button-start-order']",
            popover: {
              title: 'Bereit?',
              description:
                'Wenn du bereit bist, deinen Auftrag zu starten, klicke hier.',
              position: 'left',
            },
          },
        ],
      },
    ],
  },
  [HelpRegistryMappings.SANDBOX_BUILDING_OVERVIEW]: {
    key: HelpRegistryMappings.SANDBOX_BUILDING_OVERVIEW,
    title: 'Building Overview',
    items: [
      {
        id: 'building-overview-operations',
        label: 'Gebäudeübersicht - Bedienung',
        action: 'showDriver',
        steps: [
          {
            element: "div[data-testid='buildingCard_active']",
            popover: {
              title: 'Aktives Gebäude',
              description: 'Dies zeigt an, dass dieses Gebäude ausgewählt ist.',
              position: 'right',
            },
          },
          {
            element: "div[data-testid='addFloorOGButton']",
            popover: {
              title: 'Etage hinzufügen',
              description:
                'Um eine Etage NACH OBEN hinzuzufügen, kannst du diesen Button verwenden.',
              position: 'top',
            },
          },
          {
            element: "div[data-testid='addFloorUGButton']",
            popover: {
              title: 'Etage hinzufügen',
              description:
                'Um eine Etage NACH UNTEN hinzuzufügen, kannst du diesen Button verwenden.',
              position: 'top',
            },
          },
          {
            element: "button[data-testid='uploadButton']",
            popover: {
              title: 'Speichern',
              description:
                'Möchtest du deinen Fortschritt speichern? Dann ist dieser Button genau richtig!',
              position: 'bottom',
            },
          },
          {
            element: "button[data-testid='closeOrderBtn']",
            popover: {
              title: 'Auftrag abschließen',
              description:
                'Wenn du vollständig mit allen Arbeiten fertig bist, kannst du den Auftrag schließen.Dies kann nicht rückgängig gemacht werden.',
              position: 'bottom',
            },
          },
        ],
      },
      {
        id: 'building-overview-operations',
        label: 'Installationsort auswählen',
        action: 'showDriver',
        steps: [
          {
            element: "button[data-testid='openInspectedBuildingFormButton']",
            popover: {
              title: 'GW-Installationsorte in einem Schritt festlegen',
              description:
                'Bei mehreren Gateways kannst du hier anhand der gespeicherten Radiochecks die finalen Montageorte auswählen.',
              position: 'right',
              onNextClick: (element, step, { driver }) => {
                element?.click();
                setTimeout(() => driver.moveNext(), 500);
              },
            },
          },
          {
            element: "table[data-testid='installationLocationsTable']",
            popover: {
              title: 'Gespeicherte Radiochecks in einer Tabelle',
              description:
                'Messe nacheinander mehrere mögliche Montageorte und vergleiche die Empfangsqualität direkt in der Tabelle. Wähle am Ende den besten Ort aus.',
              position: 'bottom',
            },
          },
          {
            element: "button[data-testid='button-save']",
            popover: {
              title: 'Auswahl speichern',
              description: 'Speichere am Ende deine Aushwahl.',
              position: 'bottom',
              onNextClick: (element, step, { driver }) => {
                element?.click();
                setTimeout(() => driver.moveNext(), 500);
              },
            },
          },
          {
            element: "div[data-testid='gateway-status-badge']",
            popover: {
              title: 'Geeignete Installationsorte klar markiert',
              description:
                'Wenn mehrere Gateways installiert werden, erhalten die final ausgewählten Orte einen Badge mit Checkbox. Andere gespeicherte GW-Montageorte musst du nicht löschen.',
              position: 'bottom',
              onNextClick: (element, step, { driver }) => {
                (
                  document.querySelector(
                    "div[data-testid='roomGroupName']"
                  ) as HTMLElement
                )?.click();
                setTimeout(() => {
                  (
                    document.querySelector(
                      "div[data-testid='sideMenuButtonToggle']"
                    ) as HTMLElement
                  )?.click();
                  setTimeout(() => driver.moveNext(), 700);
                }, 500);
              },
            },
          },
          {
            element: "div[data-testid='0x64052a50_optionsDropdown']",
            popover: {
              title: 'LoraWAN Gateway Eingabemaske öffnen',
              description:
                'ÖFfne die LoraWAN Gateway Eingabemaske, um eine Auswahl zum geeigneten Installationsort zu treffen.',
              position: 'right',
              onNextClick: (element, step, { driver }) => {
                element?.click();
                setTimeout(() => {
                  (
                    document.querySelector(
                      "button[data-testid='editDeviceButton']"
                    ) as HTMLElement
                  )?.click();
                  setTimeout(() => driver.moveNext(), 1500);
                }, 500);
              },
            },
          },
          {
            element:
              "span[data-testid='checkbox_isInstallationLocation_checkbox']",
            popover: {
              title: 'Finale Auswahl gleich nach dem Radiocheck',
              description:
                'Finale Auswahl kann auch gleich nach dem Radicheck getroffen werden. Die Auswahl wird in die Tabelle übernommen.',
              position: 'bottom',
            },
          },
          {
            element: "button[data-testid='button-save']",
            popover: {
              title:
                'Nur gespeicherte Radiochecks erscheinen in der Abschlusstabelle',
              description:
                'Speichere das Ergebnis, wenn du es später in der Tabelle vergleichen möchtest. Hierzu ist es notwenidg, den elektrischen Anschluss und ein Foto zu dokumentieren.',
              position: 'bottom',
            },
          },
        ],
      },
      {
        id: 'building-overview-help',
        label: 'Ich komme nicht weiter, was soll ich tun?',
        action: 'showDriver',
        steps: [
          {
            element: "em[data-testid='toggleServiceListButton']",
            popover: {
              title: 'Auftragsnotizen',
              description:
                'Wenn du dir unsicher bist, was zu tun ist, schaue in den Auftragsnotizen nach. Dort findest du alle notwendigen Informationen zu deinen Aufgaben.',
              position: 'right',
              onNextClick: (element, step, { driver }) => {
                element?.click();
                setTimeout(() => driver.moveNext(), 500);
              },
            },
          },
          {
            element: "div[data-testid='customerSupportInfoCard']",
            popover: {
              title: 'Kundensupport kontaktieren',
              description:
                'Hier findest du die Telefonnummer des Kundensupports.',
              position: 'right',
            },
          },
        ],
      },
    ],
  },
};

export default helpRegistry;

export type HelpAction = 'showInfo' | 'showDriver';

export interface HelpActionItem {
  id: string;
  label: string;
  action: HelpAction;
  content?: string;
  steps?: Array<{
    element?: string | HTMLElement;
    popover?: {
      title?: string;
      description?: string;
      position?: 'top' | 'bottom' | 'left' | 'right' | 'auto' | 'mid-center';
      onNextClick?: (element: any, step: any, context: { driver: any }) => void;
      onPreviousClick?: (
        element: any,
        step: any,
        context: { driver: any }
      ) => void;
      onCloseClick?: (
        element: any,
        step: any,
        context: { driver: any }
      ) => void;
    };
  }>;
}

export interface HelpContext {
  key: string;
  title: string;
  items: HelpActionItem[];
}

export type HelpRegistry = Record<string, HelpContext>;
